import React from "react";
import ReactiveComponent from "@appbaseio/reactivesearch/lib/components/basic/ReactiveComponent";

import { useReactifySearchContext } from "../../hooks";

export const SensorCustom: React.FC = () => {
  const reactifySearchContext = useReactifySearchContext();

  const sensors = reactifySearchContext.options.mode === "collection" ? reactifySearchContext.config.sensors.collection : reactifySearchContext.config.sensors.search;

  return (
    <>
      {sensors.map((item, index) => 
        <ReactiveComponent
          key={`SensorCustom_${index}`}
          componentId={`SensorCustom_${index}`}
          customQuery={() => item}
        />
      )}
    </>
  );
};
